import React, {useState, useEffect, useMemo} from 'react'
import {connect} from "react-redux";
import {toast} from "react-toastify";
import ButtonBack from "../../widgets/button_back";
import ButtonNext from "../../widgets/button_next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUser, faEnvelope, faPhone} from "@fortawesome/free-solid-svg-icons";

function Part3({next, user, carrito_redux}) {
    const [carrito, setCarrito] = useState(carrito_redux);
    const [name, setName] = useState(user.name);
    const [email, setEmail] = useState(user.email);
    const [phone, setPhone] = useState('');
    const [errors, setErrors] = useState({});

    const subTotal = useMemo(() => {
        return carrito.reduce((acc, producto) => {
            let price = producto.price;
            if (producto.has_offer) {
                price = producto.offer_price;
            }
            return acc + price * producto.quantity;
        }, 0);
    }, [carrito]);

    const totalItems = useMemo(() => {
        return carrito.reduce((acc, p) => acc + p.quantity, 0);
    }, [carrito]);


    useEffect(() => {
        let data_entrega = JSON.parse(localStorage.getItem('data_entrega')) ?? '';
        if (data_entrega) {
            setName(data_entrega.name);
            setEmail(data_entrega.email);
            setPhone(data_entrega.phone);
        }

    }, []);

    const validateField = (field, value) => {
        const newErrors = {...errors};
        if (field === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (value && !emailRegex.test(value)) {
                newErrors.email = 'Correo inválido';
            } else {
                delete newErrors.email;
            }
        }
        if (field === 'phone') {
            const phoneRegex = /^\+?[0-9]{7,15}$/;
            if (value && !phoneRegex.test(value)) {
                newErrors.phone = 'Número inválido';
            } else {
                delete newErrors.phone;
            }
        }
        setErrors(newErrors);
    };

    const volver = () => {
        next(1);
    }
    const siguiente = () => {
        // trim para evitar espacios
        if (!name.trim() || !email.trim() || !phone.trim()) {
            toast.error("Por favor completa todos los campos");
            return;
        }

        // validar email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            toast.error("Correo electrónico inválido");
            return;
        }

        // validar teléfono
        const phoneRegex = /^\+?[0-9]{7,15}$/;
        if (!phoneRegex.test(phone)) {
            toast.error("Número de teléfono inválido");
            return;
        }

        // si todo está OK
        const data = {
            phone,
            name,
            email,
        };

        localStorage.setItem("data_entrega", JSON.stringify(data));
        next(3);
    };

    return (
        <>
            <main className="w-full min-h-screen bg-gray-50">
                <div className="container mx-auto px-3 md:px-6 py-6 md:py-8">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">

                        {/* Contact Form */}
                        <div className="lg:col-span-2">
                            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                                {/* Header */}
                                <div className="px-5 md:px-6 pt-5 md:pt-6 pb-4 border-b border-gray-100">
                                    <div className="flex items-center gap-3">
                                        <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center">
                                            <FontAwesomeIcon icon={faUser} className="text-ecoprimary1"/>
                                        </div>
                                        <div>
                                            <h2 className="text-xl font-bold text-gray-900">Datos de contacto</h2>
                                            <p className="text-sm text-gray-500">Información para coordinar tu pedido</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="px-5 md:px-6 py-6 space-y-5">
                                    {/* Name */}
                                    <div>
                                        <label className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                                            <FontAwesomeIcon icon={faUser} className="text-xs text-gray-400"/>
                                            Nombre completo
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Ingresa tu nombre"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-ecoprimary1 focus:ring-2 focus:ring-blue-100 transition-all duration-200"
                                        />
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                                        {/* Email */}
                                        <div>
                                            <label className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                                                <FontAwesomeIcon icon={faEnvelope} className="text-xs text-gray-400"/>
                                                Correo electrónico
                                            </label>
                                            <input
                                                type="email"
                                                value={email}
                                                className={`w-full px-4 py-3 border-2 rounded-xl text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 transition-all duration-200 ${
                                                    errors.email
                                                        ? 'border-red-300 focus:border-red-400 focus:ring-red-100'
                                                        : 'border-gray-200 focus:border-ecoprimary1 focus:ring-blue-100'
                                                }`}
                                                onChange={(e) => {
                                                    setEmail(e.target.value);
                                                    validateField('email', e.target.value);
                                                }}
                                                placeholder="correo@ejemplo.com"
                                            />
                                            {errors.email && (
                                                <p className="mt-1.5 text-xs text-red-500 font-medium">{errors.email}</p>
                                            )}
                                        </div>
                                        {/* Phone */}
                                        <div>
                                            <label className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                                                <FontAwesomeIcon icon={faPhone} className="text-xs text-gray-400"/>
                                                Celular / WhatsApp
                                            </label>
                                            <input
                                                type="text"
                                                className={`w-full px-4 py-3 border-2 rounded-xl text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 transition-all duration-200 ${
                                                    errors.phone
                                                        ? 'border-red-300 focus:border-red-400 focus:ring-red-100'
                                                        : 'border-gray-200 focus:border-ecoprimary1 focus:ring-blue-100'
                                                }`}
                                                value={phone || ''}
                                                onChange={(e) => {
                                                    setPhone(e.target.value);
                                                    validateField('phone', e.target.value);
                                                }}
                                                placeholder="+59173643349"
                                            />
                                            {errors.phone && (
                                                <p className="mt-1.5 text-xs text-red-500 font-medium">{errors.phone}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="px-5 md:px-6 py-4 border-t border-gray-100">
                                    <ButtonBack onClick={volver} label="← Volver"/>
                                </div>
                            </div>
                        </div>

                        {/* Summary */}
                        <div className="lg:col-span-1">
                            <div className="lg:sticky lg:top-24">
                                <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                                    <div className="px-5 md:px-6 pt-5 md:pt-6 pb-4 border-b border-gray-100">
                                        <h2 className="text-lg font-bold text-gray-900">Resumen del pedido</h2>
                                    </div>

                                    <div className="px-5 md:px-6 py-5">
                                        <div className="flex justify-between items-center py-3">
                                            <span className="text-sm text-gray-500">Subtotal ({totalItems} productos)</span>
                                            <span className="text-sm font-semibold text-gray-700">Bs {subTotal.toFixed(2)}</span>
                                        </div>
                                        <div className="flex justify-between items-center py-3 border-b border-gray-100">
                                            <span className="text-sm text-gray-500">Envío</span>
                                            <span className="text-sm font-medium text-gray-400">Coordinación interna</span>
                                        </div>

                                        <div className="flex justify-between items-center py-4">
                                            <span className="text-base font-bold text-gray-900">Total estimado</span>
                                            <span className="text-xl font-bold text-ecoprimary1">Bs {subTotal.toFixed(2)}</span>
                                        </div>

                                        <ButtonNext
                                            className="w-full mt-2"
                                            onClick={siguiente}
                                            label="Continuar →"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}

const mapStateToProps = state => ({
    user: state.Auth.user,
    carrito_redux: state.Cart.carrito,
})

export default connect(mapStateToProps, {})(Part3)